module.exports = __webpack_public_path__ + "assets/media/1.241deb1b.wav";